import React, {Component} from 'react';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LayoutSidebar} from "../../Layout";
import {ClientTabs} from "./ClientTabs";
import {ClientHeader} from "./ClientHeader";
import {BusinessUnitList} from "./BusinessUnitList";
import {ERROR_AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT} from "../../settings/settings";
import {Modal, ModalFooter, ModalHeader} from "reactstrap";
import {BusinessUnitRow} from "./BusinessUnitRow";
import {SaveButton} from "../business_units/SaveButton";
import {ClientAdAccountAndStoresList} from "./ad_accounts/ClientAdAccountAndStoresList";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';
import {fetchCustomMetrics} from "../../hooks/useCustomMetrics";
import {setCustomMetricLabelsCache} from "../dashboard/columns";

class ClientMonitoringComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            businessUnits: null,
            name: '',
            is_confirming_to_link_ad_accounts_to_client: false,
            business_unit_activating_id: null,
            isSaving: false,
            clientAdAccounts: null,
            clientStores: null,
            channels: null
        };

        this.handleBusinessUnitDelete = this.handleBusinessUnitDelete.bind(this);
        this.handleBusinessUnitStatusChange = this.handleBusinessUnitStatusChange.bind(this);
        this.handleAfterSuccessfulBusinessUnitSubmit = this.handleAfterSuccessfulBusinessUnitSubmit.bind(this);
        this.toggleConfirmingLinksAdAccounts = this.toggleConfirmingLinksAdAccounts.bind(this)
        this.handleActivateBusinessUnitLinkingAdAccountsToClient = this.handleActivateBusinessUnitLinkingAdAccountsToClient.bind(this);
        this.handleClientAdAccountRemove = this.handleClientAdAccountRemove.bind(this);
        this.handleClientAdAccountSuccessfullyEdited = this.handleClientAdAccountSuccessfullyEdited.bind(this);
        this.handleClientAdAccountSuccessfullyAdded = this.handleClientAdAccountSuccessfullyAdded.bind(this)
        this.handleClientStoreSuccessfullyEdited = this.handleClientStoreSuccessfullyEdited.bind(this);
        this.handleClientStoreSuccessfullyAdded = this.handleClientStoreSuccessfullyAdded.bind(this)
    }

    handleClientAdAccountSuccessfullyEdited(clientAdAccountId) {
        const { t } = this.props;
        this.updateClientData();
        alert(t('clients.account_edited_successfully'));
    }

    handleClientAdAccountSuccessfullyAdded(clientAdAccountId) {
        const { t } = this.props;
        this.updateClientData();
        alert(t('clients.account_linked_successfully'))
    }

    handleClientAdAccountRemove(clientAdAccountId) {
        this.setIsSaving(true);
        const removeAdAccountURL = this.getClientAdAccountRemoveURL(clientAdAccountId)
        new APIClient(removeAdAccountURL).call('DELETE').then((data) => {
            if (data.status === 'ERROR') {
                this.setIsSaving(false);
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.updateClientData();
            }
        })
    }

    handleClientStoreSuccessfullyEdited(clientAdAccountId) {
        const { t } = this.props;
        this.updateClientData();
        alert(t('clients.store_edited_successfully'));
    }

    handleClientStoreSuccessfullyAdded(clientAdAccountId) {
        const { t } = this.props;
        this.updateClientData();
        alert(t('clients.store_connected_successfully'))
    }

    getDeleteBusinessUnitURL(configId) {
        return `${API_URL}business-unit/${configId}/delete`
    }

    getClientAdAccountRemoveURL(clientAdAccountId) {
        return `${API_URL}client/ad_account/${clientAdAccountId}/remove`
    }

    handleAfterSuccessfulBusinessUnitSubmit(businessUnitId) {
        this.props.history.push(`/business-unit/${businessUnitId}/accounts?showAddAccountModal=true`);
    }

    handleBusinessUnitDelete(businessUnitId) {
        const deleteBusinessUnitURL = this.getDeleteBusinessUnitURL(businessUnitId)
        // Borrado físico: el backend exige confirm en el body (el modal ya confirmó al usuario).
        new APIClient(deleteBusinessUnitURL).call('DELETE', {confirm: true}).then((data) => {
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.updateClientData();
            }
        })
    }

    getStatusChangeBusinessUnitURL(businessUnitId, action) {
        return `${API_URL}business-unit/${businessUnitId}/${action}`
    }

    handleActivateBusinessUnitLinkingAdAccountsToClient() {
        this.handleBusinessUnitStatusChange(this.state.business_unit_activating_id, BusinessUnitRow.action_activate, true);
    }

    setIsSaving(new_value) {
        this.setState({
            ...this.state,
            'isSaving': new_value
        });
    }

    handleBusinessUnitStatusChange(businessUnitId, action, comingFromModal=false) {
        this.setIsSaving(true);
        const statusChangeBusinessUnitURL = this.getStatusChangeBusinessUnitURL(businessUnitId, action)
        new APIClient(statusChangeBusinessUnitURL).call('PUT', {'add_ada_to_cli_if_none': comingFromModal}).then((data) => {
            if (data.status === ERROR_AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT) {
                this.setState({
                    ...this.state,
                    'is_confirming_to_link_ad_accounts_to_client': true,
                    'business_unit_activating_id': businessUnitId,
                    'isSaving': false
                });
            } else if (data.status === 'ERROR') {
                alert(data['error_message']);
            }

            this.updateClientData(comingFromModal);
        })
    }


    updateClientData(forceCloseModal=false) {
        new APIClient(this.updateClientDataURL()).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                this.setIsSaving(false);
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                let modalState = {
                    'is_confirming_to_link_ad_accounts_to_client': this.state.is_confirming_to_link_ad_accounts_to_client,
                    'business_unit_activating_id': this.state.business_unit_activating_id,
                }

                if(forceCloseModal) {
                    modalState = {
                        'is_confirming_to_link_ad_accounts_to_client': false,
                        'business_unit_activating_id': null
                    }
                }

                this.setState({
                    ...this.state,
                    ...modalState,
                    isSaving: false,
                    name: data.data['name'],
                    businessUnits: data.data['business_units'],
                    clientAdAccounts: data.data['client_ad_accounts'],
                    clientStores: data.data['client_stores'],
                    channels: data.data['channels']
                });
            }
        })
    }

    toggleConfirmingLinksAdAccounts() {
        // Si estamos saliendo del modal sin aceptar
        if(this.state.is_confirming_to_link_ad_accounts_to_client) {
            this.setState({
                ...this.state,
                'is_confirming_to_link_ad_accounts_to_client': false,
                'business_unit_activating_id': null

            });
        }
        else{
            throw new Error("no tenia que haber llegado aca")
        }
    }

    componentDidMount() {
        this.updateClientData();
        // Los objetivos con métrica custom se muestran con su nombre legible ("CUSTOM:6" no):
        // esta pantalla hidrata el cache de display_names por su cuenta (solo el Dashboard lo
        // llena vía basic-data). El setState fuerza el re-render con los labels resueltos.
        fetchCustomMetrics().then((items) => {
            setCustomMetricLabelsCache(items);
            this.setState({customMetricLabelsReady: true});
        });
    }

    updateClientDataURL() {
        return API_URL + 'client/' + this.props.match.params.id;
    }

    render() {
        const { t } = this.props;
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <ClientHeader name={this.state.name}/>
                    <ClientTabs clientId={this.props.match.params.id}/>

                    <div className="section-body h-items" style={{paddingBottom:'0px'}}>
                        <BusinessUnitList
                            afterSuccessfulBusinessUnitSubmit={this.handleAfterSuccessfulBusinessUnitSubmit}
                            clientId={this.props.match.params.id}
                            businessUnits={this.state.businessUnits}
                            clientName={this.state.name}
                            doBusinessUnitStatusChange={this.handleBusinessUnitStatusChange}
                            doBusinessUnitDelete={this.handleBusinessUnitDelete}
                        />
                    </div>
                    <div className="section-body h-items">
                        <ClientAdAccountAndStoresList
                            afterSuccessfulClientAdAccountSubmit={this.handleClientAdAccountSuccessfullyAdded}
                            afterSuccessfulClientStoreSubmit={this.handleClientStoreSuccessfullyAdded}
                            clientId={this.props.match.params.id}
                            clientAdAccounts={this.state.clientAdAccounts}
                            clientStores={this.state.clientStores}
                            channels={this.state.channels}
                            clientName={this.state.name}
                            doClientAdAccountRemove={this.handleClientAdAccountRemove}
                            doClientAdAccountEdit={this.handleClientAdAccountSuccessfullyEdited}
                            doClientStoreRemove={this.handleClientAdAccountRemove}
                            doClientStoreEdit={this.handleClientStoreSuccessfullyEdited}
                            isSaving={this.state.isSaving}
                        />
                    </div>

                </section>
                <Modal key="modal" isOpen={this.state.is_confirming_to_link_ad_accounts_to_client}
                       toggle={this.toggleConfirmingLinksAdAccounts} className="modal-body">
                    <ModalHeader toggle={this.toggleConfirmingLinksAdAccounts}>{t('clients.link_ad_accounts_title')}</ModalHeader>
                    <div className="modal-section">
                        <p>{t('clients.link_business_unit_message')}<br/><br/></p>
                        <p>{t('clients.link_business_unit_question')}</p>
                    </div>
                    <ModalFooter>
                    <div style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            textAlign: "center",
                            clear:"both"
                        }}>
                            <div style={{margin:"0 10px"}}>
                                <input onClick={this.toggleConfirmingLinksAdAccounts} type="button" value={t('client.no_button')} className="btn -alt"/>
                            </div>
                            <div style={{margin:"0 10px"}}>
                                <SaveButton text={t('client.yes_button')} isSaving={this.state.isSaving} onClick={this.handleActivateBusinessUnitLinkingAdAccountsToClient} hasChanges={true} />
                                {/*<input onClick={this.handleActivateBusinessUnitLinkingAdAccountsToClient} type="button" value="Sí" className="btn -alt"/>*/}
                            </div>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default withRouterParams(withTranslation()(ClientMonitoringComponent));
